'use client';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import { useToggle } from '../hooks';

interface IProps extends PropsWithChildren {
  label: string | ReactNode;
  open: boolean;
  className?: string;
}

export const Accordion = ({ label, open, children, className }: IProps) => {
  const [show, toggleShow] = useToggle(open);

  return (
    <>
      <div onClick={toggleShow} className={className}>
        <div className="cursor-pointer w-full h-[54px] bg-white rounded-md flex items-center justify-between">
          {label}

          <div className="flex pr-2">
            <p>{show ? 'Hide' : 'View'}</p>
            {show ? <IconChevronUp /> : <IconChevronDown />}
          </div>
        </div>
      </div>
      <div style={{ display: show ? 'block' : 'none' }}>{children}</div>
    </>
  );
};

interface V2Props extends PropsWithChildren {
  showLabel: string | ReactNode;
  hideLabel: string | ReactNode;
  open: boolean;
  className?: string;
  borderStyles?: string;
}

export const AccordionV2 = ({
  showLabel,
  hideLabel,
  open,
  children,
  className = '',
  borderStyles = '',
}: V2Props) => {
  const [show, toggleShow] = useToggle(open);

  return (
    <div>
      <div className={className}>
        <div style={{ display: show ? 'block' : 'none' }}>{children}</div>
        <div
          onClick={toggleShow}
          className={classNames(
            `cursor-pointer w-full h-[40px] bg-transparent flex gap-2 items-center justify-center ${borderStyles}`,
            { 'mt-6': show }
          )}
        >
          {show ? hideLabel : showLabel}

          {show ? <IconChevronUp /> : <IconChevronDown />}
        </div>
      </div>
    </div>
  );
};
